(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-thumbnails"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-thumbnails-carousel')) {
    const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');
    const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
    const SWIPE_THRESHOLD = 8;
    const PREFETCH_LIMIT = 5;

    const saveData = () => Boolean(navigator.connection?.saveData);

    class VariantThumbnailsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        if (this.querySelector('.variant-thumbnails__track')) {
          this.init();
        } else {
          requestAnimationFrame(() => this.init());
        }
      }

      init() {
        if (this.ready) return;
        this.track = this.querySelector('.variant-thumbnails__track');
        if (!this.track) return;

        this.ready = true;
        this.abortController = new AbortController();
        this.undoStack = [];
        this.previewToken = 0;
        this.lastPointerType = 'mouse';
        this.prefetched = false;

        this.status = this.querySelector('.variant-thumbnails__status');
        this.card =
          this.closest('product-card') ||
          this.closest('.product-card') ||
          this.closest('.card-wrapper');

        // Hook for the scoped touch-hover reset. Keeps the global stylesheet
        // from reaching cards that do not use this block.
        this.card?.setAttribute('data-vt-card', '');

        this.prevBtn = this.querySelector('.variant-thumb-arrow--prev');
        this.nextBtn = this.querySelector('.variant-thumb-arrow--next');

        if (this.dataset.fallbackActive === 'true') {
          this.thumbs[0]?.classList.add('is-active');
        }
        // Baseline the preview restores to. Reassigned when a touch tap commits.
        this.baselineThumb = this.querySelector('.variant-thumb-item.is-active') || this.thumbs[0];

        this.bindArrows();
        this.bindThumbs();
        this.observeOverflow();
        this.revealBaseline();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.ready = false;
      }

      get thumbs() {
        return Array.from(this.querySelectorAll('.variant-thumb-item:not(.variant-thumb-item--more)'));
      }

      get gallery() {
        return this.card?.querySelector('.card-gallery, [ref="cardGallery"]') || null;
      }

      get slideshow() {
        return this.card?.querySelector('slideshow-component, [ref="slideshow"]') || null;
      }

      // Horizon only wires up the slideshow's scroller when more than one slide
      // is visible at connect time, and its `slides` getter skips [hidden] ones.
      // A card whose media are all variant images ships every unselected slide
      // as [hidden], so the scroller is never built and `select()` bails out
      // before it can reveal anything. Detect that and drive the slides here.
      get slideshowIsLive() {
        const slideshow = this.slideshow;
        if (!slideshow || typeof slideshow.select !== 'function') return false;
        return (slideshow.slides?.length ?? 0) > 1;
      }

      get scrollBehavior() {
        return REDUCED_MOTION.matches ? 'auto' : 'smooth';
      }

      /* ---------------- Overflow, arrows, scroll position ---------------- */

      observeOverflow() {
        const { signal } = this.abortController;
        const schedule = () => {
          cancelAnimationFrame(this.rafId);
          this.rafId = requestAnimationFrame(() => this.measure());
        };

        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(this.track);
        this.resizeObserver.observe(this);

        this.track.addEventListener('scroll', schedule, { passive: true, signal });

        this.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', schedule, { once: true, signal });
        });

        this.measure();
      }

      measure() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const overflows = scrollWidth > clientWidth + 2;
        const atStart = scrollLeft <= 2;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;

        this.dataset.overflow = String(overflows);
        this.dataset.atStart = String(atStart);
        this.dataset.atEnd = String(atEnd);

        if (this.prevBtn) this.prevBtn.disabled = !overflows || atStart;
        if (this.nextBtn) this.nextBtn.disabled = !overflows || atEnd;
      }

      // A shopper arriving on ?variant= for the ninth colorway should see that
      // colorway's thumbnail, not have to hunt for it off-screen. scrollLeft is
      // set directly rather than via scrollIntoView, which would also scroll the
      // page and yank the grid around on load.
      revealBaseline() {
        if (!this.baselineThumb) return;
        const offset =
          this.baselineThumb.offsetLeft -
          (this.track.clientWidth - this.baselineThumb.offsetWidth) / 2;
        this.track.scrollLeft = Math.max(0, offset);
      }

      bindArrows() {
        const { signal } = this.abortController;

        const scrollByPage = (direction) => (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.track.scrollBy({
            left: direction * this.track.clientWidth * 0.75,
            behavior: this.scrollBehavior,
          });
        };

        this.prevBtn?.addEventListener('click', scrollByPage(-1), { signal });
        this.nextBtn?.addEventListener('click', scrollByPage(1), { signal });
      }

      /* ---------------- Interaction ---------------- */

      bindThumbs() {
        const { signal } = this.abortController;
        const hoverEnabled = this.dataset.hoverPreview === 'true';
        const tapAgainToOpen = this.dataset.tapAgain === 'true';

        let pointerStartX = 0;
        let pointerStartY = 0;
        let swiping = false;

        this.addEventListener(
          'pointerdown',
          (event) => {
            this.lastPointerType = event.pointerType || 'mouse';
            swiping = false;
            pointerStartX = event.clientX;
            pointerStartY = event.clientY;
            this.prefetchColorways();
          },
          { passive: true, signal }
        );

        this.track.addEventListener(
          'pointermove',
          (event) => {
            if (event.buttons === 0 && event.pointerType === 'mouse') return;
            const dx = Math.abs(event.clientX - pointerStartX);
            const dy = Math.abs(event.clientY - pointerStartY);
            if (dx > SWIPE_THRESHOLD || dy > SWIPE_THRESHOLD) swiping = true;
          },
          { passive: true, signal }
        );

        this.addEventListener(
          'click',
          (event) => {
            const thumb = event.target.closest('.variant-thumb-item');
            if (!thumb || thumb.classList.contains('variant-thumb-item--more')) return;

            // A swipe that happens to end on a thumbnail is not a tap.
            if (swiping) {
              event.preventDefault();
              event.stopPropagation();
              swiping = false;
              return;
            }

            if (FINE_POINTER.matches) return; // mouse click opens the PDP

            // Touch: the already-selected colorway is a second tap, so let it
            // through to the PDP. Anything else previews in place.
            if (tapAgainToOpen && thumb === this.baselineThumb) return;

            event.preventDefault();
            event.stopPropagation();
            if (this.lastPointerType === 'touch') thumb.blur();
            this.commit(thumb);
          },
          { signal }
        );

        if (!hoverEnabled) return;

        this.addEventListener(
          'pointerover',
          (event) => {
            if (event.pointerType === 'touch' || !FINE_POINTER.matches) return;
            const thumb = event.target.closest('.variant-thumb-item');
            if (!thumb || thumb.classList.contains('variant-thumb-item--more')) return;
            this.prefetchColorways();
            this.activate(thumb);
          },
          { signal }
        );

        // Restore on leaving the whole card, not each thumbnail, so sliding
        // across the strip does not flicker back to the default image.
        (this.card || this).addEventListener('pointerleave', () => this.restore(), { signal });

        this.addEventListener(
          'focusin',
          (event) => {
            const thumb = event.target.closest('.variant-thumb-item');
            if (thumb && !thumb.classList.contains('variant-thumb-item--more')) this.activate(thumb);
          },
          { signal }
        );

        this.track.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape') {
              this.restore();
              return;
            }
            const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
            if (!step) return;
            const thumbs = this.thumbs;
            const index = thumbs.indexOf(document.activeElement);
            const next = thumbs[index + step];
            if (!next) return;
            event.preventDefault();
            next.focus();
          },
          { signal }
        );
      }

      // Warm the full-size colorway images on first contact so the hover swap
      // is instant rather than a visible load. Skipped on metered connections.
      prefetchColorways() {
        if (this.prefetched || saveData()) return;
        this.prefetched = true;

        this.thumbs.slice(0, PREFETCH_LIMIT).forEach((thumb) => {
          const src = thumb.dataset.imageSrc;
          if (!src) return;
          const img = new Image();
          img.decoding = 'async';
          img.fetchPriority = 'low';
          img.src = src;
        });

        // The slides themselves pick a different srcset candidate than the
        // thumbnail's data-image-src, and a lazy image inside a display:none
        // slide never starts loading. Without this the reveal shows an empty
        // frame until the real candidate arrives.
        this.gallery?.querySelectorAll('slideshow-slide[hidden] img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
          img.fetchPriority = 'low';
        });
      }

      /* ---------------- Preview state ---------------- */

      activate(thumb) {
        if (thumb === this.currentThumb) return;
        this.currentThumb = thumb;
        this.markActive(thumb);
        this.swapMedia(thumb);
        this.retargetLinks(thumb.getAttribute('href'));
      }

      // A touch tap is a decision, not a preview: drop the undo history so the
      // choice survives, move the baseline, and announce it.
      commit(thumb) {
        this.activate(thumb);
        this.undoStack.length = 0;
        this.baselineThumb = thumb;
        this.announce(thumb.dataset.color);
      }

      restore() {
        while (this.undoStack.length) this.undoStack.pop()();
        this.currentThumb = null;
        if (this.baselineThumb) this.markActive(this.baselineThumb);
      }

      markActive(thumb) {
        this.thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          if (active) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        });
      }

      announce(color) {
        if (!this.status || !color) return;
        this.status.textContent = color;
      }

      // Every mutation registers its own reversal, so restore() is exact rather
      // than a guess at what the markup looked like beforehand.
      mutate(apply, undo) {
        this.undoStack.push(undo);
        apply();
      }

      swapMedia(thumb) {
        const gallery = this.gallery;
        if (!gallery) return;

        const mediaId = thumb.dataset.mediaId;

        // 1. Preferred: hand off to the theme so its own state stays correct.
        //    Only when its slideshow is actually live -- otherwise the call is a
        //    silent no-op and the shopper sees no swap at all.
        if (typeof this.card?.previewVariant === 'function' && mediaId && this.slideshowIsLive) {
          this.card.previewVariant(mediaId);
          return;
        }

        // 2. Reveal an existing slide if the theme already rendered this media.
        if (mediaId) {
          const target = gallery.querySelector(`slideshow-slide[slide-id="${CSS.escape(mediaId)}"]`);
          if (target) {
            const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
            const snapshot = slides.map((slide) => ({
              slide,
              hidden: slide.hasAttribute('hidden'),
              reveal: slide.hasAttribute('reveal'),
              ariaHidden: slide.getAttribute('aria-hidden'),
            }));

            this.mutate(
              () => {
                slides.forEach((slide) => {
                  slide.setAttribute('hidden', '');
                  slide.removeAttribute('reveal');
                  slide.setAttribute('aria-hidden', 'true');
                });
                target.removeAttribute('hidden');
                target.setAttribute('reveal', '');
                target.setAttribute('aria-hidden', 'false');
              },
              () => {
                snapshot.forEach(({ slide, hidden, reveal, ariaHidden }) => {
                  slide.toggleAttribute('hidden', hidden);
                  slide.toggleAttribute('reveal', reveal);
                  if (ariaHidden === null) {
                    slide.removeAttribute('aria-hidden');
                  } else {
                    slide.setAttribute('aria-hidden', ariaHidden);
                  }
                });
              }
            );
            return;
          }
        }

        // 3. Last resort: swap the src of the visible image only. Touching
        //    hidden slides destroys the theme's second-image-on-hover.
        const img =
          gallery.querySelector('slideshow-slide:not([hidden]) img') ||
          gallery.querySelector('img');
        if (!img) return;

        const src = thumb.dataset.imageSrc;
        const srcset = thumb.dataset.imageSrcset;
        if (!src) return;

        const previous = { src: img.src, srcset: img.srcset };
        const token = ++this.previewToken;

        const preloader = new Image();
        if (srcset) preloader.srcset = srcset;
        preloader.sizes = img.sizes || '';
        preloader.src = src;

        const commit = () => {
          if (token !== this.previewToken) return; // a newer preview won
          this.mutate(
            () => {
              img.src = src;
              if (srcset) img.srcset = srcset;
            },
            () => {
              img.src = previous.src;
              img.srcset = previous.srcset;
            }
          );
        };

        if (preloader.complete) {
          commit();
        } else {
          preloader.addEventListener('load', commit, { once: true });
          preloader.addEventListener('error', commit, { once: true });
        }
      }

      retargetLinks(href) {
        if (!href || !this.card) return;

        const links = this.card.querySelectorAll(
          'a.product-card__link, a[ref="productCardLink"], a[ref="cardGalleryLink"], a[ref="productTitleLink"], .product-title a'
        );

        links.forEach((link) => {
          const previous = link.getAttribute('href');
          this.mutate(
            () => link.setAttribute('href', href),
            () => link.setAttribute('href', previous)
          );
        });
      }
    }

    customElements.define('variant-thumbnails-carousel', VariantThumbnailsCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
